<template>
  <v-app id="inspire">
    <v-navigation-drawer
      app
      dark
      permanent
      :mini-variant.sync="mini"
      v-if="userInfo.isAuthenticated"
      >
      <v-list-item class="px-2">
        <v-app-bar-nav-icon @click.stop="mini = !mini" v-if="userInfo.isAuthenticated"></v-app-bar-nav-icon>
      </v-list-item>
      <v-list-item class="px-2" :title="userInfo.email">
        <v-list-item-avatar color="#00469C">
          <v-icon>mdi-account</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ userInfo.email }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item-group v-model="selectedItem">
          <div v-for="route in getUserSection" :key="route.id">
            <v-list-item link v-if="(route.name == 'consignment' && userInfo.isConsignment) || route.name != 'consignment'" :title="$t(route.display)"  @click="routeTo(route.name)" >
              <v-list-item-icon>
                <v-icon>{{ route.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t(route.display) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-divider></v-divider>
          <v-subheader inset v-if="getShipmentSection.length > 0 && !mini">{{ $t('label.shipments') }}</v-subheader>
          <v-list-item link v-for="route in getShipmentSection" :key="route.id" :title="$t(route.display)" @click="routeTo(route.name)">
            <v-list-item-icon>
              <v-icon>{{ route.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(route.display) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <v-list dense>
          <v-list-item :title="$t('label.changePassword')" @click.stop="isChangePasswordDialogOpen = true">
            <v-list-item-icon>
              <v-icon>mdi-form-textbox-password</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('label.changePassword') }}</v-list-item-title>
          </v-list-item>
          <!-- <v-btn color="error" block @click="logout()"><v-icon small>mdi-logout</v-icon> {{ $t('label.logout') }}</v-btn> -->
          <v-list-item :title="$t('label.logout')" @click.stop="logout()">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('label.logout') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="#00469C"
      dense
      flat
      dark
    >
      <!-- <v-app-bar-nav-icon @click.stop="isDrawerOpen = !isDrawerOpen" v-if="userInfo.isAuthenticated"></v-app-bar-nav-icon> -->
      <v-toolbar-title class="mr-12 align-center">
        <span class="title">{{ userInfo.vendorName }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <language-menu></language-menu>
      <v-img :src="require('@/assets/logo.png')" max-width="150px"></v-img>
    </v-app-bar>

    <v-main>
      <v-slide-y-transition mode="out-in">
        <router-view style="width: auto !important; max-width: none;"></router-view>
      </v-slide-y-transition>
      <v-snackbar
        v-model="snackbar.visible"
        :bottom="snackbar.y === 'bottom'"
        :left="snackbar.x === 'left'"
        :multi-line="snackbar.mode === 'multi-line'"
        :right="snackbar.x === 'right'"
        :timeout="snackbar.timeout"
        :top="snackbar.y === 'top'"
        :vertical="snackbar.mode === 'vertical'"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="primary"
            @click="hideMessage"
            text
            small
            v-bind="attrs"
          >
            {{ $t('label.close') }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
   <v-dialog v-model="isChangePasswordDialogOpen" max-width="700" persistent>
      <change-password @cancel="isChangePasswordDialogOpen = false" @saved="isChangePasswordDialogOpen = false"></change-password>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { userInfo } from './mixins'
// import MenuList from './components/navigationDrawer/MenuList'
// import UserInformation from './components/navigationDrawer/UserInformation'
import LanguageMenu from './components/navbar/LanguageMenu'
import ChangePassword from './components/users/ChangePassword'
import authService from './helpers/authService'
import menuOptions from './utils/menuOptions'

export default {
  name: 'App',
  components: { LanguageMenu, ChangePassword },
  mixins: [userInfo],
  data: () => ({
    isDrawerOpen: true,
    isChangePasswordDialogOpen: false,
    mini: true,
    selectedItem: 0
  }),
  computed: {
    ...mapGetters('snackbarModule', ['snackbar']),
    getUserSection () {
      return menuOptions.getUserSection()
    },
    getShipmentSection () {
      return menuOptions.getShipmentSection()
    }
  },
  methods: {
    ...mapActions('snackbarModule', ['hideMessage']),
    logout () {
      authService.logout()
      this.$router.push({ name: 'login' })
    },
    routeTo (route) {
      if (this.$route.name !== route) {
        this.$router.push({ name: route })
      }
    }
  }
}
</script>
